import { getMetricDropdownLabel } from '../../Utils/chart_utils';
import moment from 'moment';

export function mapDataForLineHighcharts(statData, teamColors, stat, showTitle = true, showHamburger = true, forceTitle = "", showDataLabels = false, pageType = "team", showBodyWeightBaseline = false) {

  const data = statData?.data || [];
  const optionsV2 = statData?.optionsV2 || [];
  if (!data) return;

  const chartData = data.map((dataPoint) => {
    let restructuredDataPoint = {
      date: dataPoint.date,
      disp_date: moment(dataPoint.date).format("MM-DD"),
    }
    optionsV2.forEach(option => {
      restructuredDataPoint[option.name] = dataPoint[option.name];
    });
    return restructuredDataPoint;
  });

  const series = optionsV2.map((item, index) => {
    return {
      name: item.name,
      type: 'line',
      yAxis: 0,
      data: chartData.map(innerItem => innerItem[item.name] || null),
      color: teamColors[index % teamColors.length],
      dataLabels: {
        enabled: showDataLabels,
        format: '{y}',
      }
    }
  });

  let referenceLines = []
  // Add baseline series for any option that has a baseline value
  optionsV2.forEach((item, index) => {
    if ((item.baseline !== undefined) && showBodyWeightBaseline) {
      referenceLines.push({
        id: 'avg',
        dashStyle: 'Dash',
        color: 'black',
        value: Math.round(item.baseline),
        zIndex: 5,
        label: {
          text: `Body Weight Baseline: ${Math.round(item.baseline)}`,
          align: 'right',
          x: -10
        }
      })
    }
  });

  const categories = chartData.map(item => item.disp_date)
  let title
  if (forceTitle) {
    title = forceTitle
  } else {
    title = (showTitle ? getMetricDropdownLabel("ASDF", false) : '');
  }

  // Set legend position based on pageType
  const legendConfig = pageType === "profile"
    ? {
      enabled: true,
      align: 'center',
      verticalAlign: 'top',
      layout: 'horizontal'
    }
    : {
      enabled: true,
      align: 'right',
      verticalAlign: 'middle',
      layout: 'vertical'
    };

  const options = {
    chart: {
      type: 'line'
    },
    title: {
      text: title
    },
    xAxis: {
      categories: categories,
      labels: categories.length > 20
        ? {
          rotation: -90,
          overflow: 'justify',
          staggerLines: 1,
          step: 0
        }
        : categories.length > 10
          ? {
            rotation: -45,
            overflow: 'justify',
            staggerLines: 1,
            step: 0
          }
          : {
            rotation: 0,
          },
      tickmarkPlacement: categories.length > 10 ? 'on' : 'between',
      crosshair: true,
      gridLineWidth: 1,
      gridLineColor: '#e6e6e6'
    },
    yAxis: [
      {
        title: {
          text: null
        },
        labels: {
          format: '{value}'
        },
        startOnTick: true,
        endOnTick: true,
        plotLines: referenceLines
      },
      {
        title: {
          text: null
        },
        labels: {
          format: '{value}'
        },
        opposite: true,
        startOnTick: true,
        endOnTick: true
      },
    ],
    tooltip: {
      shared: true
    },
    legend: legendConfig,
    plotOptions: {
      connectNulls: true,
      series: {
        // This connects points even if some data is null
        connectNulls: true,
        events: {
          legendItemClick: function() {
            // Allow default behavior (show/hide series)
            // Highcharts will automatically rescale the y-axis
            return true;
          }
        }
      },
      column: {
        grouping: true,
        shadow: false,
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          y: categories.length > 20 ? 10 : 0,
          rotation: categories.length > 20 ? 270 : 0,
          inside: true
        }
      }
    },
    series: series,
    exporting: {
      enabled: showHamburger
    }
  };

  return options;
}